import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { useEffect, useState } from "react";

// Import base theme
import baseTheme from "./themes/baseTheme";

// Default theme to use when no match is found
const DEFAULT_THEME = baseTheme;

const ChakraWrapper = ({ children }) => {
    const [currentTheme, setCurrentTheme] = useState(DEFAULT_THEME);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTheme = async () => {
            try {
                // Get the current hostname
                const hostname = window.location.hostname;
                
                // Extract subdomain (everything before the first dot)
                const subdomain = hostname.split('.')[0];
                
                // Map subdomain to theme
                let themeName = 'default';
                if (subdomain === 'assessments') {
                    themeName = 'dominion';  // assessments.dominionpsych.co.za
                } else if (subdomain === 'transnet') {
                    themeName = 'transnet'; // transnet.dominionpsych.co.za
                } else if (subdomain === 'africanbank') {
                    themeName = 'africanbank'; // africanbank.dominionpsych.co.za
                } else if (subdomain === 'psytech') {
                    themeName = 'psytech'; // psytech.betapersona.com
                }
                // else: default (localhost, www, or any other subdomain)

                
                // Try to dynamically import the theme file
                try {
                    const themeModule = await import(`./themes/${themeName}Theme.js`);
                    const selectedTheme = themeModule.default;
                    const finalTheme = extendTheme(selectedTheme);
                    setCurrentTheme(finalTheme);
                    
                    console.log(`Theme loaded: ${themeName}Theme.js`);
                } catch (importError) {
                    console.warn(`Theme file not found: ${themeName}Theme.js, using default theme`);
                    setCurrentTheme(extendTheme(DEFAULT_THEME));
                }
                
            } catch (error) {
                console.error('Error loading theme:', error);
                setCurrentTheme(extendTheme(DEFAULT_THEME));
            } finally {
                setLoading(false);
            }
        };

        loadTheme();
    }, []);

    if (loading) {
        return <ChakraProvider theme={extendTheme(DEFAULT_THEME)}>{children}</ChakraProvider>;
    }

    return <ChakraProvider theme={currentTheme}>{children}</ChakraProvider>;
};

export default ChakraWrapper;
